import { ActivityAlias } from "./ActivityAlias";
import { Trade } from "./Trade";

import { PaginatedResponse } from "../ServiceHelpers/ServiceResponse";

export interface Activity {
    id: number;
    name: string;
    nameNormalized: string;
    isActive: boolean;
    isLocked: boolean;
    aliases: ActivityAlias[];
    trades: Trade[];
    updatedAt: string;
    updatedBy: string;
    rowVersion: string | null;
}

export type ActivityListDTO = PaginatedResponse<Activity>;

export interface ActivityPostDTO {
    activityId: number;
    newRowVersion: string | null;
    statusCode: number;
    message: string | null;
}

export interface TradeLinkDTO {
    activityId: number;
    tradeId: number;
    activityTradeId: number;
    statusCode: number;
    message: string | null;
}

/**
 * This is here to have an "easy to access" way of understanding what an empty
 *   activity would look like.  This can be used for setting default variables
 *   or used to check agains uninitialized Activity fields
 */
export const EMPTY_ACTIVITY: Activity = {
    id: -1,
    name: '',
    nameNormalized: '',
    aliases: [],
    trades: [],
    isActive: true,
    isLocked: false,
    updatedAt: '',
    updatedBy: '',
    rowVersion: null
};
